import { CURRENCY_SYMBOLS } from '@ezugi/constants/currencySymbols';

const getSymbolByCurrencyCode = (code: string): string => {
  if (code in CURRENCY_SYMBOLS) {
    return CURRENCY_SYMBOLS[code as keyof typeof CURRENCY_SYMBOLS];
  }

  return code;
};

export default getSymbolByCurrencyCode;
